module.exports = __webpack_public_path__ + "img/card_background.4140275b.png";